import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_10 = { class: "input-group top_search" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_12 = { class: "checkbox-wrapper" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_14 = { class: "float-end" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add User", -1 /* HOISTED */);
const _hoisted_17 = { class: "col-xs-12 col-sm-12" };
const _hoisted_18 = { class: "card bg-white data-grid company-detail-grid detached" };
const _hoisted_19 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_21 = { class: "hidden-sm" };
const _hoisted_22 = { class: "hidden-sm" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm" }, "\r\n\t\t\t\t\t\t\t\t\tAuthorized Systems\r\n\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_24 = { class: "text-center hidden-sm" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-unlock" }, null, -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_29 = { class: "hidden-sm" };
const _hoisted_30 = { class: "hidden-sm" };
const _hoisted_31 = { class: "text-center text-uppercase hidden-sm" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        class: "text-center",
        colspan: "4"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, _hoisted_8)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.site,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.site) = $event)),
                            options: _ctx.sites,
                            "track-by": "value",
                            label: "text",
                            showLabels: false,
                            placeholder: "Any site",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_b_form_checkbox, {
                            id: "includeArchivedUsers",
                            modelValue: _ctx.query.includeDeleted,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_router_link, {
                            to: { name: 'user', params: { 'id': 'new', 'companyId': _ctx.companyId } }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, { variant: "primary" }, {
                                    default: _withCtx(() => [
                                        _hoisted_15,
                                        _hoisted_16
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                    ])
                ])
            ]),
            _createTextVNode(),
            _withDirectives(_createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("table", _hoisted_19, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_20,
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'UserName', title: 'User' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_21, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'SiteName', title: 'Site' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_22, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'RoleName', title: 'Role' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _hoisted_23
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: _normalizeClass({ 'deleted': item.whenDeleted })
                                }, [
                                    _createElementVNode("td", _hoisted_24, [
                                        _createVNode(_component_b_button_group, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_b_dropdown, {
                                                    variant: "outline-secondary dots",
                                                    size: "sm",
                                                    onClick: ($event) => (_ctx.edit(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_dropdown_item, {
                                                            onClick: ($event) => (_ctx.edit(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_25,
                                                                _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                        _createTextVNode(),
                                                        (item.whenLockoutEnds && _ctx.isPowerShield)
                                                            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                key: 0,
                                                                onClick: ($event) => (_ctx.unlock(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_26,
                                                                    _createTextVNode(" Unlock\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(),
                                                        _createVNode(_component_b_dropdown_divider),
                                                        _createTextVNode(),
                                                        _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                            onClick: ($event) => (_ctx.archive(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_27,
                                                                _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                            [_vShow, !item.whenDeleted]
                                                        ]),
                                                        _createTextVNode(),
                                                        _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                            onClick: ($event) => (_ctx.restore(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_28,
                                                                _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                            [_vShow, item.whenDeleted]
                                                        ])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, [
                                        _createVNode(_component_router_link, {
                                            to: { name: 'user', params: { 'id': item.userId } },
                                            class: "blue"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.userName), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(item.siteId ? item.siteName : 'All'), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_30, _toDisplayString(item.roleName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_31, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass({
                                                'badge badge-danger': !item.numberOfSystems && !item.whenGrantedAccessToAllSystems,
                                                'badge badge-success': item.whenGrantedAccessToAllSystems,
                                                'badge badge-warning': item.numberOfSystems
                                            })
                                        }, _toDisplayString(item.whenGrantedAccessToAllSystems ? 'All' : (item.numberOfSystems || 'None')), 3 /* TEXT, CLASS */)
                                    ])
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createTextVNode(),
                        (_ctx.noData)
                            ? (_openBlock(), _createElementBlock("tfoot", _hoisted_32, _hoisted_34))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_b_pagination, {
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        class: "float-end"
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ])
    ]));
}
